import {
	Model,
	OutboundFreight,
	SalesOrderError,
	User,
	YardSchedule,
	YardTrip
} from ".";

export default class SalesOrder extends Model {
	get singularNoun() {
		return "sales order";
	}

	get mutations() {
		return {
			errors: SalesOrderError,
			outboundFreight: OutboundFreight,
			schedules: YardSchedule,
			trips: YardTrip,
			userSignedBy: User
		};
	}

	resource() {
		return "sales/sales-orders";
	}
}
